@if(isVisible()){
<div class="flex">
  <mat-toolbar>
    @if (insertVisible()) {
      <button class="btn" (click)="doInsert($event)" matTooltip="新增" [disabled]="insertDisabled"
      [class.btn-disabled]="insertDisabled"
      [class.btn-insert]="!insertDisabled"
      >
        <mat-icon fontIcon="add" slot="start" name="add-outline"></mat-icon>
      </button>
    }
    @if (editVisible()) {
      <button class="btn" (click)="doEdit($event)" matTooltip="修改" [disabled]="editDisabled"
      [class.btn-disabled]="editDisabled"
      [class.btn-edit]="!editDisabled"
      >
        <mat-icon fontIcon="edit" slot="start" name="create-outline"></mat-icon>
      </button>
    }
    @if (postVisible()) {
      <button class="btn" (click)="doPost($event)" matTooltip="確定" [disabled]="postDisabled"
      [class.btn-disabled]="postDisabled"
      [class.btn-post]="!postDisabled"
      >
        <mat-icon fontIcon="done" slot="start" name="checkmark-outline"></mat-icon>
      </button>
    }
    @if (cancelVisible()) {
      <button class="btn" (click)="doCancel($event)" matTooltip="取消" [disabled]="cancelDisabled"
      [class.btn-disabled]="cancelDisabled"
      [class.btn-cancel]="!cancelDisabled"
      >
        <mat-icon fontIcon="cancel" slot="start" name="close-outline"></mat-icon>
      </button>
    }
    @if (deleteVisible()) {
      <button class="btn" (click)="doDelete($event)" matTooltip="刪除" [disabled]="deleteDisabled"
      [class.btn-disabled]="deleteDisabled"
      [class.btn-delete]="!deleteDisabled"
      >
        <mat-icon fontIcon="delete" slot="start" name="trash-outline"></mat-icon>
      </button>
    }
    @if(editAndSaveVisible()){
    <button class="btn" (click)="doEditAndSave($event)"
      [class.btn-disabled]="editAndSaveDisabled()"
      [class.btn-editAndSave]="!editAndSaveDisabled()"
    >存檔</button>
    }
    @if (user1Visible) {
      <button class="btn"  id="u1" (click)="user1($event)" [disabled]="user1Disabled()">
        {{userCaption1}}
      </button>
    }
    @if (user2Visible) {
      <button class="btn"  id="u2" (click)="user2($event)" [disabled]="user2Disabled()">
        {{userCaption2}}
      </button>
    }
    @if (user3Visible) {
      <button class="btn"  id="u3" (click)="user3($event)" [disabled]="user3Disabled()">
        {{userCaption3}}
      </button>
    }
    @if (user4Visible) {
      <button class="btn"  id="u4" (click)="user4($event)" [disabled]="user4Disabled()">
        {{userCaption4}}
      </button>
    }
  </mat-toolbar>
  @if(navigateVisible()){
    <mat-toolbar>
      @if (firstVisible()) {
        <button class="btn"  (click)="onFirstRow()" matTooltip="第一筆" [disabled]="firstDisabled"
        [class.btn-disabled]="firstDisabled"
        [class.btn-first]="!firstDisabled">
          <mat-icon>first_page</mat-icon>
        </button>
      }
      @if (previousVisible) {
        <button class="btn"  (click)="onPreviousRow()" matTooltip="上一筆" [disabled]="previousDisabled"
        [class.btn-disabled]="previousDisabled"
        [class.btn-previous]="!previousDisabled">
          <mat-icon>navigate_before</mat-icon>
        </button>
      }
      @if (nextVisible) {
        <button class="btn" (click)="onNextRow()" matTooltip="下一筆" [disabled]="nextDisabled"
        [class.btn-disabled]="nextDisabled"
        [class.btn-next]="!nextDisabled">
          <mat-icon>navigate_next</mat-icon>
        </button>
      }
      @if (lastVisible) {
        <button class="btn" (click)="onLastRow()" matTooltip="最後一筆" [disabled]="lastDisabled"
        [class.btn-disabled]="lastDisabled"
        [class.btn-last]="!lastDisabled"
        >
          <mat-icon>last_page</mat-icon>
        </button>
      }
    </mat-toolbar>
    }

</div>
}
